<template>
    <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
      <div slot="title" class="dialog-title-container">
        <span class="title-label"><i class="el-icon-document"></i> 票据表单</span>
        <i class="el-icon-error" @click="close"></i>
      </div>
      <el-row class="form-top-btns">
        <el-button type="primary" size="mini" plain round icon="em-icon-save" @click="saveHandler">提交保存</el-button>
        <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
      </el-row>
      <div class="form-container" style="overflow-y: scroll;">
        <!--表单-->
        <el-form ref="form" :model="formData" size="mini" label-width="100px" style="width: 370px;">
          <!--字段-->
          <el-form-item label="创建人">
            {{formData.creater_name}}
          </el-form-item>
          <el-form-item label="创建时间">
            {{formData.create_time}}
          </el-form-item>
          <el-form-item label="部门">
            <span>{{formData.department_name}}</span>
          </el-form-item>
          <el-form-item label="类型" required>
            <el-select v-if="formData.id === '0'" v-model="formData.transport_type" size="mini">
                <el-option v-for="item in transport_typeArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span v-else>{{formData.transport_type}}</span>
          </el-form-item>
          <el-form-item v-if="formData.transport_type === '笼子'" label="笼号" style="width:295px">
            <el-input v-if="formData.id === '0'" placeholder="笼号" v-model="formData.basketNo"></el-input>
            <span v-else>{{formData.basketNo}}</span>
          </el-form-item>
          <el-form-item v-if="formData.transport_type === '托盘'" label="托盘号" style="width:295px">
            <el-input v-if="formData.id === '0'" placeholder="托盘号" v-model="formData.palletNo"></el-input>
            <span v-else>{{formData.palletNo}}</span>
          </el-form-item>
          <el-form-item v-if="formData.transport_type === '托盘'" label="托盘种类" required>
            <el-select v-if="formData.id === '0'" v-model="formData.pallet_type" size="mini">
                <el-option v-for="item in pallet_typeArry" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span v-else>{{formData.pallet_type}}</span>
          </el-form-item>
          <el-form-item v-if="formData.transport_type === '托盘' && formData.department_name === '粘贴'" v-for="(item,index) in formData.pageArray" :key="item.id" class="demo-form-inline">
            <el-input style="width:40% !important" v-if="formData.id === '0'" placeholder="页码" v-model="item.page"></el-input>
            <el-input style="width:40% !important" v-if="formData.id === '0'" placeholder="箱子数量" v-model="item.box_no"></el-input>
            <span v-if="formData.id !== '0'">页码：{{item.page}}</span>
            <span style="margin-left:20px" v-if="formData.id !== '0'">箱子数量：{{item.box_no}}</span>
            <el-button style="width:10% !important" v-if="formData.id === '0'" type="danger" @click="delPage(item,index)">-</el-button>
          </el-form-item>
          <el-form-item v-if="formData.transport_type === '托盘' && formData.id === '0' && formData.department_name === '粘贴'">
            <el-button type="primary" @click="addPage">+</el-button>
          </el-form-item>
          <el-form-item v-if="formData.transport_type === '托盘' && formData.department_name !== '粘贴'" label="箱子数量" style="width:295px" required>
            <el-input v-if="formData.id === '0'" placeholder="箱子数量" v-model="formData.plan_box_num"></el-input>
            <span v-else>{{formData.plan_box_num}}</span>
          </el-form-item>
          <el-form-item label="样本册类型" required>
            <el-select v-if="formData.id === '0'" v-model="formData.product_type" size="mini">
                <el-option v-for="item in product_typeArry" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span v-else>{{formData.product_type}}</span>
          </el-form-item>
          <el-form-item label="样本册分期">
            <el-select v-if="formData.id === '0'" v-model="formData.product_phase" size="mini">
                <el-option v-for="item in product_phaseArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span v-else>{{formData.product_phase}}</span>
          </el-form-item>
          <el-form-item label="样本册" required>
            <el-autocomplete
              v-if="formData.id === '0'"
              size="mini"
              popper-class="my-autocomplete"
              v-model="formData.product_name"
              :fetch-suggestions="querySearchAsyncForm"
              placeholder="请输入样本册"
              @select="handleSelectForm"
              @blur="handblurForm"
            >
              <i
                class="el-icon-edit el-input__icon"
                slot="suffix"
                @click="handleIconClickForm"
              >
              </i>
              <template slot-scope="{ item }">
                <span>{{ item.name }}({{item.book_number}})</span>
              </template>
            </el-autocomplete>
            <span v-else>{{formData.product_name}}</span>
          </el-form-item>
          <el-form-item label="返库分期" style="width:295px" required>
            <el-input v-if="formData.id === '0'" placeholder="返库分期" v-model="formData.phase"></el-input>
            <span v-else>{{formData.phase}}</span>
          </el-form-item>
          <el-form-item label="丁合机分区" style="width:295px">
            <el-input v-if="formData.id === '0'" placeholder="丁合机分区" v-model="formData.district"></el-input>
            <span v-else>{{formData.district}}</span>
          </el-form-item>
          <el-form-item label="标记" style="width:295px" required>
            <el-input v-if="formData.id === '0'" placeholder="标记" v-model="formData.mark"></el-input>
            <span v-else>{{formData.mark}}</span>
          </el-form-item>
          <el-form-item v-if="formData.id === '0' && (formData.department_name === '制本' || formData.department_name === '断裁' || formData.department_name === '资材')" label="票据数量" style="width:295px" required>
            <el-input-number v-model="formData.numNote" :min="1" :max="15"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </template>
  
  <script>
  export default {
    name: 'UserDialogForm',
    props: {
      parent: {
        type: Object,
        default: () => null
      }
    },
    data: function () {
      return {
        isShow: false,
        formData: null,
        formEmptyData: {
          id: '0',
          department_id:'',
          department_name:'',
          transport_type: '',
          basketNo:'',
          palletNo:'',
          pallet_type: '',
          plan_box_num: 0,
          phase:'',
          district: '',
          mark: '',
          external_id: '',
          product_type: '',
          product_id:'',
          product_name:'',
          creater_id: sessionStorage.getItem("operator_id"),
          creater_name: sessionStorage.getItem("operator"),
          create_time: '',
          pageArray:[{id:Math.random(),page:'',box_no:''}],
          numNote: 1
        },
        transport_typeArray:[{id:'托盘',name:'托盘'},{id:'笼子',name:'笼子'}],
        product_phaseArray: [{id:'前',name:'前'},{id:'中',name:'中'},{id:'后',name:'后'}],
        pallet_typeArry:[{id:'塑料',name:'塑料'},{id:'木头',name:'木头'},{id:'铁',name:'铁'}],
        outstoreArry:[],
        product_typeArry:[{id:'成品',name:'成品'},{id:'半成品',name:'半成品'},{id:'板块',name:'板块'},{id:'不良品',name:'不良品'},{id:'发泡机器',name:'发泡机器'},{id:'备品',name:'备品'}],
        currentTime: ''
      }
    },
    beforeCreate: function () {
      
    },
    created: function () {
      this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
      this.loadOutstore()
      this.loadProductForm();
    },
    mounted: function () {
    },
    methods: {
      generateId: function() {
        var id = Math.floor(Math.random() * 1000); // 生成一个介于0到999之间的随机整数作为ID
        return "id_" + id; // 将ID添加前缀"id_"并返回结果
      },
      loadDepartment: function () {
        const _this = this
        _this.post(_this.$apis.getDepartmentList, {userId:sessionStorage.getItem("operator_id")}, function (res) {
          const _json = res.data
          _this.formData.department_id = _json.departments[0].id
          _this.formData.department_name = _json.departments[0].name
        })
      },
      loadOutstore: function () {
        const _this = this
        _this.post(_this.$apis.getOutStoreList, {}, function (res) {
          const _json = res.data
          _this.outstoreArry = _json.outstores
        })
      },
      loadProductForm: function() {
        let _this = this;
        _this.get(_this.$apis.getInstoreProduct, {}, function(res) {
          _this.productListForm = res.data.dataList;
        });
      },
      querySearchAsyncForm: function(queryString, cb) {
        this.product_check_form = "false";
        var results = queryString
          ? this.productListForm.filter(this.createStateFilterForm(queryString))
          : this.productListForm;
  
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 500 * Math.random());
      },
      createStateFilterForm: function(queryString) {
        return product => {
          return product.name.indexOf(queryString) > -1;
        };
      },
      handleSelectForm: function(item) {
        let _this = this;
        _this.product_check_form = "true";
        _this.formData.product_name = item.name+ '('+item.book_number+')';
        _this.formData.product_id = item.id;
      },
      handleIconClickForm: function(ev) {
        console.log(ev);
      },
      handblurForm: function() {
        if (this.product_check_form === "false") {
          this.formData.product_name = "";
          this.formData.product_id = "";
        }
      },
      loadData: function () {
        let _this = this
        _this.post(_this.$apis.getPalletForm, { Id: _this.formData.id }, function (res) {
          let _json = res.data
          if (_json.pallet !== null) {
            _this.formData = _json.pallet
          } else {
            _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
            _this.formData.create_time = _this.currentTime
            _this.loadDepartment()
          }
        })
      },
      // 用于父窗体新增
      addHandler: function () {
        var date = new Date()
        var month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
        var day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
        var hours = date.getHours() <= 9 ? '0' + date.getHours() : date.getHours()
        var mins = date.getMinutes() <= 9 ? '0' + date.getMinutes() : date.getMinutes()
        this.currentDate = date.getFullYear() + '-' + month + '-' + day
        this.currentTime = date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + mins
        this.formData.id = '0'
        this.loadData()
        this.isShow = true
      },
      viewHandler: function (formId) {
        this.formData.id = formId
        this.loadData()
        this.isShow = true
      },
      // 关闭事件
      close: function () {
        this.$confirm('确定关闭？', '提示', {})
          .then(_ => {
            this.isShow = false
          })
          .catch(_ => {
            return false
          })
      },
      // 保存方法
      saveHandler: function () {
        let _this = this
        if (_this.validationHandler()) {
          if(this.formData.transport_type !== '托盘') {
            this.formData.palletNo = '';
            this.formData.pallet_type = '';
            this.formData.plan_box_num = 0;
          }
          if(this.formData.transport_type !== '笼子') {
            this.formData.basketNo = ''
            if(this.formData.department_name === '粘贴') {
              for(let i = 0; i< this.formData.pageArray.length; i++) {
                this.formData.plan_box_num += parseInt(this.formData.pageArray[i].box_no)
              }
            }
          }
          _this.post(_this.$apis.savePallet, _this.formData, function (res) {
              let _json = res.data
              if (_json.status === 'ok') {
                  _this.$message({
                  message: '操作成功',
                  type: 'success'
                  })
                  _this.isShow = false
                  _this.parent.loadData()
              } else {
                  _this.$message({
                  message: '操作失败',
                  type: 'error'
                  })
              }
          })
        }
      },
      // 验证
      validationHandler: function () {
        let _this = this
        if (this.formData.transport_type === '') {
          _this.$message({
            type: 'error',
            message: '类型不能为空'
          })
          return false
        }
        if(this.formData.transport_type === '托盘') {
          if (this.formData.pallet_type === '') {
            _this.$message({
              type: 'error',
              message: '托盘种类不能为空'
            })
            return false
          }
          if(this.formData.department_name === '粘贴' && (this.formData.pageArray[0].page === '' || this.formData.pageArray[0].box_no === '')) {
            _this.$message({
              type: 'error',
              message: '页码和箱子数量不能为空'
            })
            return false
          }
        }
        if (this.formData.product_type === '') {
          _this.$message({
            type: 'error',
            message: '样本册类型不能为空'
          })
          return false
        }
        if (this.formData.product_id === '') {
          _this.$message({
            type: 'error',
            message: '样本册不能为空'
          })
          return false
        }
        if (this.formData.phase === '') {
          _this.$message({
            type: 'error',
            message: '返库分期不能为空'
          })
          return false
        }
        if(this.formData.mark === '') {
          _this.$message({
            type: 'error',
            message: '标记不能为空'
          })
          return false
        }
  
        return true
      },
      delPage(item,index) {
        if(this.formData.pageArray.length === 1) {
          return false;
        }
        this.formData.pageArray.splice(index,1)
      },
      addPage(item) {
        this.formData.pageArray.push({
          id: Math.random(),
          page:'',
          box_no:''
        })
      }
    },
    components: {
      
    }
  }
  </script>
  